const config = {
  API_URL: process.env.REACT_APP_API_URL,
  UPDATES_API_URL: process.env.REACT_APP_UPDATES_API_URL,
  UPDATES_SOCKET_API_URL: process.env.REACT_APP_SOCKET_API_URL,
}
export default { config }
